import { useWindowSize } from 'react-use';
import { Loader, PageLayout, TOP_BAR_HEIGHT } from 'shared-ui';
import React, { useMemo } from 'react';

import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import { AppRoute, AppRouteWithParams } from 'routing/AppRoute.enum';
import { useIsExactPath } from 'hooks/useIsExactPath/useIsExactPath';

import { UserPermissionsBar } from './userPermissionsBar/UserPermissionsBar';
import { UserPermissionsProps } from './UserPermissions.types';
import { UserFunctionalPermissions } from './userFunctionalPermissions/UserFunctionalPermissions';
import { UserDataPermissions } from './userDataPermissions/UserDataPermissions';

const ADDITIONAL_PAGE_HEIGHT = 50;

export const UserPermissions = ({ onSubmit, isLoading, isSaving, onCancel, organizations }: UserPermissionsProps) => {
  const { formatMessage } = useLocale();
  const { height: windowHeight } = useWindowSize();

  const isUserDataPermissionsView = useIsExactPath(AppRouteWithParams.userDataPermissions.path);
  const isUserFunctionalPermissionsView = useIsExactPath(AppRouteWithParams.userFunctionalPermissions.path);

  const currentPage = useMemo<React.ReactNode>(() => {
    switch (true) {
      case isUserDataPermissionsView:
        return <UserDataPermissions organizations={organizations} />;
      case isUserFunctionalPermissionsView:
        return <UserFunctionalPermissions />;
      default:
        return null;
    }
  }, [isUserDataPermissionsView, isUserFunctionalPermissionsView, organizations]);

  return (
    <PageLayout
      header={formatMessage({ id: AppMessages['users.title'] })}
      withBackButton={{
        onClick: (navigate) => navigate(AppRoute.users),
      }}
      renderContent={({ headerHeight, paddingBottom, paddingTop }) => (
        <>
          <UserPermissionsBar onSubmit={onSubmit} isSaving={isSaving} onCancel={onCancel} />

          <div
            style={{
              maxHeight:
                windowHeight - headerHeight - paddingBottom - paddingTop - TOP_BAR_HEIGHT - ADDITIONAL_PAGE_HEIGHT,
              overflow: 'auto',
            }}
          >
            {isLoading ? <Loader /> : currentPage}
          </div>
        </>
      )}
    />
  );
};
